var cartTog;

$(function(){

	var navTog = $('#nav-toggle'),
		mobNav = $('#nav-mobile');
  	cartTog = $('#basket-toggle');
  	
	navTog.click(function(){
		body.toggleClass('nav-open');
		body.removeClass('cart-open');
	});
	cartTog.click(function(){
		if(body.is('.cart-open')){
			body.removeClass('nav-open cart-open');
		} else{
			body.addClass('nav-open cart-open');
		}
	});
	mobNav.find('ul.l1').each(function(){
		var expand = $('<button>',{class:'expand', "aria-label": "Sub Menu"});
		$(this).closest('li.l0').addClass('has-expand').append(expand);
		expand.click(function(){
			$(this).toggleClass('active').siblings('ul.l1').slideToggle(200);
		});
	});
});